<template>
  <div>
    <div v-if="$auth.policies['view-period-list']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <Breadcrumbs
          :headline="route.meta.title"
          :link="[{ text: 'Tài chính', href: '#' }, { text: route.meta.title }]"
        />
        <DialogClassSetup @save="saveClassSetup" />
      </div>
      <!-- <v-card outlined class="pa-9 pr-3 mx-4 mb-6 elevation-0">
      
    </v-card> -->
      <v-card outlined class="mx-4 elevation-0 mb-16">
        <TuitionFeeClassSetup />
      </v-card>
    </div>
    <div v-else>
      <Page403 />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import filterPeriod from '@/modules/tuitionFee/tuitionFeePeriod/filterPeriod'
import ListPeriod from '@/modules/tuitionFee/tuitionFeePeriod/ListPeriod'
import GroupDialog from '@/modules/tuitionFee/group/GroupDialog'
import TuitionFeeClassSetup from '@/modules/tuitionFee/class-setup/TuitionFeeClassSetup.vue'
import DialogClassSetup from '@/modules/tuitionFee/class-setup/DialogClassSetup.vue'
import Page403 from '@/views/Page403.vue'

export default {
  components: {
    Breadcrumbs,
    filterPeriod,
    ListPeriod,
    GroupDialog,
    Page403,
    TuitionFeeClassSetup,
    DialogClassSetup,
  },
  computed: {
    route() {
      return this.$route
    },
  },
  methods: {
    saveClassSetup(payload) {
      this.$store.dispatch('tuitionFeeClassSetup/create', payload)
    },
  },
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
